<div *ngIf="!showRequest">
  <h2 *ngIf="!IsAdminMode" class="sectionTitle">
    {{'FRONT_USER.UPDATE_AGENT_PROFILE.UPDATE_AGENT_PROFILE_FORM'| translate}}</h2>

    <div *ngIf="baseRequestDTO" >
      <!--request Details summary-->
      <app-request-details [baseRequest]="baseRequestDTO"></app-request-details>
    </div>

  <div
  *ngIf="(!loggedInUser?.IsAdmin&& agentIdFound && formMode==FormMode.Edit && requestStatus == ServiceStatus.MoreInformationRequestedFromAgent) || isCompleted "
>
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.REQUIRED_INFORMATION'| translate}}</h4>
      <div class="form-group">
        <label for="MoreInformationUpdate">{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' | translate}}</label>
        <textarea [(ngModel)]="moreInformation" id="MoreInformationUpdate" name="MoreInformationUpdate" disabled
          class="form-control"></textarea>
      </div>
    </div>
</div>


  <form [formGroup]="updateAgentForm" #updateAgent >
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.REGISTRATION_FORM.AGENT'| translate}}</h4>
    </div>
    <tabset #updateAgentTabs>
      <!---tab1 -->
      <tab #tabOne heading="{{ 'FRONT_USER.AGENT_TABS.AGENT_INFO' | translate}}">
        <div class="form-container">

          <div class="form-group">
            <label for="name">{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_NAME' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="name" class="form-control" id="name" name="name"
              [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.name?.dirty && f.name?.errors) }" />
            <div *ngIf="isTabOneSubmitted ||(f.name?.dirty && f.name?.errors)" class="red ">
              <div *ngIf="f.name?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.name?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>

          </div>
          <div class="form-group">
            <label for="displayName">{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_NAME_BILL' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="displayName" class="form-control" name="displayName" id="displayName"
              [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.displayName?.dirty && f.displayName?.errors) }" />
            <div *ngIf="isTabOneSubmitted ||(f.displayName?.dirty && f.displayName?.errors)" class="red ">
              <div *ngIf="f.displayName?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.displayName?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>

          </div>

          <div class="form-group">
            <label for="phone1">{{'FRONT_USER.AGENT_REGISTRATION_FORM.PHONE1' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="phone1" class="form-control" id="phone1" name="phone1"
              [ngClass]="{ 'is-invalid':  isTabOneSubmitted ||(f.phone1?.dirty && f.phone1?.errors) }" />
            <div *ngIf="isTabOneSubmitted ||(f.phone1?.dirty && f.phone1?.errors)" class="red ">
              <div *ngIf="f.phone1?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.phone1?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>

          </div>
          <div class="form-group">
            <label for="phone2">{{'FRONT_USER.AGENT_REGISTRATION_FORM.PHONE2' | translate}}</label>
            <input type="text" formControlName="phone2" class="form-control" id="phone2" name="phone2" />
            <div *ngIf="isTabOneSubmitted ||(f.phone2?.dirty && f.phone2?.errors)" class="red ">
              <div *ngIf="f.phone2?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="fax">{{'FRONT_USER.AGENT_REGISTRATION_FORM.FAX' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="fax" class="form-control" id="fax" name="fax"
              [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.fax?.dirty && f.fax?.errors) }" />
            <div *ngIf="isTabOneSubmitted ||(f.fax?.dirty && f.fax?.errors)" class="red ">
              <div *ngIf="f.fax?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.fax?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <div *ngIf="f.fax?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>

          </div>
          <div class="form-group">
            <label for="contactPerson">{{'FRONT_USER.AGENT_REGISTRATION_FORM.CONTACT_PERSON' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="contactPerson" class="form-control" id="contactPerson"
              name="contactPerson"
              [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.contactPerson?.dirty && f.contactPerson?.errors) }" />
            <div *ngIf="isTabOneSubmitted ||(f.contactPerson?.dirty && f.contactPerson?.errors)" class="red ">
              <div *ngIf="f.contactPerson?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.contactPerson?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>

          </div>
          <div class="form-group">
            <label for="address">{{'FRONT_USER.AGENT_REGISTRATION_FORM.ADDRESS' | translate}}</label>
            <span class="red">*</span>
            <textarea formControlName="address" class="form-control" id="address" name="address"
              [ngClass]="{ 'is-invalid': isTabOneSubmitted ||(f.address?.dirty && f.address?.errors) }"></textarea>
            <div *ngIf="isTabOneSubmitted ||(f.address?.dirty && f.address?.errors)" class="red">
              <div *ngIf="f.address?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.address?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
            </div>

          </div>

          <div class="form-group" formGroupName="agentCurrency">
            <label for="currencyId">{{'FRONT_USER.AGENT_REGISTRATION_FORM.CURRENCY'| translate}}</label>
            <span class="red">*</span>

            <ng-multiselect-dropdown formControlName="currencyId" id="currencyId"
              placeholder="{{'FRONT_USER.AGENT_REGISTRATION_FORM.CURRENCY_CHOOSE' | translate}}"
              [settings]="dropdownSettings" [data]="genericLookupModel" (onDeSelect)="onItemDeSelect($event)"
              [disabled]="formMode== FormMode.Readonly" (onSelect)="onItemSelect($event)"  >
            </ng-multiselect-dropdown>
            <div
              *ngIf="isTabOneSubmitted ||(updateAgentForm.get('agentCurrency')?.get('currencyId')?.dirty && updateAgentForm.get('agentCurrency')?.get('currencyId')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCurrency')?.get('currencyId')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
            </div>
          </div>
        </div>
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(1)">{{ 'FRONT_USER.NEXT' | translate}}</button>
        </p>
      </tab>
      <!---end tab1 -->
      <!---tab2 -->
      <tab #tabTwo heading="{{ 'FRONT_USER.AGENT_TABS.AUTHORIZED_PERSONS' | translate}}" [disabled]="validateTabTwo">
        <div formArrayName="agentRepresentative">

          <div
            *ngFor="let representative of updateAgentForm.get('agentRepresentative').controls; let i=index; let last = last"
            [formGroupName]="i">
            <div class="form-container">

              <div class="form-group">
                <label
                  for="username">{{ 'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="username" class="form-control" id="username" name="username" (keydown.space)="$event.preventDefault();"
                  (change)="onChangeUserName($event,representative.get('username'))"
                  (paste)="onChangeUserName($event,representative.get('username'))"
                  (keyup)="onChangeUserName($event,representative.get('username'))"
                  (keydown)="onChangeUserName($event,representative.get('username'))"
                  [ngClass]="{ 'is-invalid':isTabTwoSubmitted ||( representative.get('username')?.dirty && representative.get('username')?.errors) }" />
                <div
                  *ngIf=" isTabTwoSubmitted ||(representative.get('username')?.dirty && representative.get('username')?.errors)"
                  class="red ">
                  <div *ngIf="representative.get('username')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="representative.get('username')?.errors?.pattern">
                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                  </div>
                  <div *ngIf="representative.get('username')?.errors?.duplicatedNumber">
                    {{'FRONT_USER.ERRORS_MESSAGES.DuplicateUserName' | translate}}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label
                  for="password">{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.PASSWORD'| translate}}</label>
                <span class="red"> *</span>
                <input type="password" formControlName="password" class="form-control" id="password" name="password"
                  [ngClass]="{ 'is-invalid': isTabTwoSubmitted ||(representative.get('password')?.dirty && representative.get('password')?.errors) }" />
                <div
                  *ngIf=" isTabTwoSubmitted ||(representative.get('password')?.dirty &&  representative.get('password')?.errors)"
                  class="red">
                  <div *ngIf="representative.get('password')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                  </div>
                  <div *ngIf="representative.get('password')?.errors?.minlength">
                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.PASSWORD_LENGTH_ERROR'| translate}}
                  </div>
                  <div *ngIf="representative.get('password')?.errors?.passwordStrength">
                    {{'FRONT_USER.PASSWORD_ERROR'| translate}}
                  </div>

                </div>
              </div>

              <div class="form-group">
                <label
                  for="nationalId">{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NATIONAL_ID'| translate}}</label>
                <span class="red"> *</span>
                <input type="text" formControlName="nationalId" class="form-control" id="nationalId" name="nationalId"
                  (change)="onChangeNational($event,representative.get('nationalId'),representative.get('UserId'))"
                  (paste)="onChangeNational($event,representative.get('nationalId'),representative.get('UserId'))"
                  (keyup)="onChangeNational($event,representative.get('nationalId'),representative.get('UserId'))"
                  (keydown)="onChangeNational($event,representative.get('nationalId'),representative.get('UserId'))"
                  [ngClass]="{ 'is-invalid': isTabTwoSubmitted ||(representative.get('nationalId')?.dirty && representative.get('nationalId')?.errors) }" />
                <div
                  *ngIf="isTabTwoSubmitted ||(representative.get('nationalId')?.dirty && representative.get('nationalId')?.errors)"
                  class="red">
                  <div *ngIf="representative.get('nationalId')?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                  </div>
                  <div *ngIf="representative.get('nationalId')?.errors?.pattern">
                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NATIONAL_ID_PATTERN_ERROR'| translate}}
                  </div>
                  <div *ngIf="representative.get('nationalId')?.errors?.duplicatedNumber">
                      {{'FRONT_USER.ERRORS_MESSAGES.DuplicateNationalId' | translate}}
                    </div>
                </div>
              </div>


              <p *ngIf="formMode != FormMode.Readonly" class="btns-holder">
                <button type="button" class="btn SCAcustomBtn"  Confirmation  (confirmationClick)="deleteRepresentative(i)"
                  *ngIf="updateAgentForm.get('agentRepresentative').controls.length > 1">
                  {{'FRONT_USER.DELETE' | translate }}
                </button>
              </p>
              <hr />
            </div>


            <!-- <span class="col btn btn-success" *ngIf="last" (click)="addFeature()">+</span> -->
            <p *ngIf="formMode!= FormMode.Readonly && last" class="btns-holder">
              <button type="button" class="btn SCAcustomBtn"  Confirmation  (confirmationClick)="addRepresentative()">(+){{'FRONT_USER.ADD' | translate }}</button>
            </p>

            <!-- <p *ngIf="!isReadOnly " class="btns-holder text-right">
                    <button type="button" class="btn SCAcustomBtn" (click)="removeRepresentative(index)">- Remove </button>
                  </p> -->

          </div>
          <p class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn"
              (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
            <button type="button" class="btn SCAcustomBtn"
              (click)="selectTab(2) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
          </p>
        </div>

      </tab>
      <!---end tab2 -->
      <!---tab3 -->
      <tab #tabThree heading="{{ 'FRONT_USER.AGENT_TABS.REQUIRED_DOCUMENTS' | translate}}"
        [disabled]="(!getValidity() && validateTabTwo) || ( !getValidity() || validateTabTwo)">
        <div class="form-container" formGroupName="agentCertificate">

          <!-- <div class="form-group" *ngIf="formMode === FormMode.Edit">
            <a [attr.href]="licensingsShipping.URL" target="_blank">{{licensingsShipping.NameEN}}</a>

          </div> -->

          <div *ngIf="formMode != FormMode.Readonly" class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.SHIPPING_LICENSING'|translate}}</label>
            <span class="red"> *</span>
            <input type="file"
              accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
              MaxSizeInMB="5" class="form-control" id="licensingsShipping" formControlName="licensingsShippingUrl"
              name="licensingsShippingUrl" (change)="onFileSelected($event,1,'ShippingProgress')" />
            <div class="upload-info">
              <span data-toggle="tooltip"
                title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
            </div>

            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="ShippingProgress + '%'">
                <span class=""> {{ShippingProgress}} % Complete</span>
              </div>
            </div>
            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('licensingsShippingUrl')?.dirty && updateAgentForm.get('agentCertificate')?.get('licensingsShippingUrl')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('licensingsShippingUrl')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('licensingsShippingUrl').errors?.notCompleted">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.SHIPPING_LICENSING'|translate}}</label>

            <a [attr.href]="uploadUrl+uploadFolder+'/'+ licensingsShipping.URL" target="_blank">
              <i class="icon-view-file"></i>
              {{licensingsShipping.NameEN}}</a>
          </div>

          <div class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.SHIPPING_EXPIRATION_DATE'|translate}}</label>
            <span class="red"> *</span>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker id="shippingExpirationDate"
              formControlName="shippingExpirationDate" 
              [ngClass]="{ 'is-invalid': formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('shippingExpirationDate')?.dirty  && updateAgentForm.get('agentCertificate')?.get('shippingExpirationDate')?.errors) }">

            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('shippingExpirationDate')?.dirty  && updateAgentForm.get('agentCertificate')?.get('shippingExpirationDate')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('shippingExpirationDate')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('shippingExpirationDate')?.errors?.inValidDateError">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>

          <!-- <div class="form-group" *ngIf="formMode === FormMode.Edit">
            <a [attr.href]="taxCard.URL" target="_blank">{{taxCard.NameEN}}</a>
          </div> -->

          <div *ngIf="formMode != FormMode.Readonly" class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD'|translate}}</label>
            <span class="red"> *</span>
            <input type="file"
              accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
              MaxSizeInMB="5" class="form-control" id="taxCard" formControlName="taxCardUrl"
              (change)="onFileSelected($event,2,'TaxCardProgress')" />
            <div class="upload-info">
              <span data-toggle="tooltip"
                title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="TaxCardProgress + '%'">
                <span class=""> {{TaxCardProgress}} % Complete</span>
              </div>
            </div>

            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxCardUrl')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxCardUrl')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('taxCardUrl')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('taxCardUrl').errors?.notCompleted">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD'|translate}}</label>

            <a [attr.href]="uploadUrl+uploadFolder+'/'+ taxCard.URL" target="_blank">
              <i class="icon-view-file"></i>
              {{taxCard.NameEN}}</a>
          </div>


          <div class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD_EXPIRATION_DATE'|translate}}</label>
            <span class="red"> *</span>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker id="taxCardExpirationDate"
              formControlName="taxCardExpirationDate"
              [ngClass]="{ 'is-invalid': formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxCardExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxCardExpirationDate')?.errors) }">

            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxCardExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxCardExpirationDate')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('taxCardExpirationDate')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('taxCardExpirationDate')?.errors?.inValidDateError">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>

          <!-- <div class="form-group" *ngIf="formMode=== FormMode.Edit && taxCardAppendix">
            <a [attr.href]="taxCardAppendix.URL" target="_blank">{{taxCardAppendix.NameEN}}</a>
          </div> -->

          <div *ngIf="formMode != FormMode.Readonly" class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD_APPENDIX'|translate}}</label>

            <input type="file"
              accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
              MaxSizeInMB="5" class="form-control" id="taxCardAppendix" formControlName="taxCardAppendixUrl"
              (change)="onFileSelected($event,3,'taxCardAppendixProgress')" />
            <div class="upload-info">
              <span data-toggle="tooltip"
                title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="taxCardAppendixProgress + '%'">
                <span class=""> {{taxCardAppendixProgress}} % Complete</span>
              </div>
            </div>
            <div *ngIf="updateAgentForm.get('agentCertificate')?.get('taxCardAppendixUrl').errors?.notCompleted">
                {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
            </div>
          </div>

          <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && taxCardAppendix">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD_APPENDIX'|translate}}</label>
            <a [attr.href]="uploadUrl+uploadFolder+'/'+ taxCardAppendix.URL" target="_blank">
              <i class="icon-view-file"></i>
              {{taxCardAppendix.NameEN}}</a>
          </div>

          <div class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_CARD_APPENDIX_EXPIRATION_DATE'|translate}}</label>
            <!-- (bsValueChange)="onValueChange($event,updateAgentForm.get('agentCertificate')?.get('taxCardAppendixExpirationDate'))" -->
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
              formControlName="taxCardAppendixExpirationDate"  >
            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxCardAppendixExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxCardAppendixExpirationDate')?.errors)"
              class="red ">
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('taxCardAppendixExpirationDate')?.errors?.inValidDateError">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>

          </div>

          <!-- <div class="form-group" *ngIf="formMode== FormMode.Edit">

            <a [attr.href]="taxAuthorization.URL" target="_blank">{{taxAuthorization.NameEN}}</a>

          </div> -->
          <div *ngIf="formMode != FormMode.Readonly" class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_AUTHORIZATION'|translate}}</label>
            <span class="red"> *</span>

            <input type="file"
              accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
              MaxSizeInMB="5" class="form-control" id="taxAuthorization" formControlName="taxAuthorizationUrl"
              (change)="onFileSelected($event,4,'taxAuthorizationProgress')"
              [ngClass]="{ 'is-invalid': formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxAuthorizationUrl')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxAuthorizationUrl')?.errors) }" />
            <div class="upload-info">
              <span data-toggle="tooltip"
                title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="taxAuthorizationProgress + '%'">
                <span class=""> {{taxAuthorizationProgress}} % Complete</span>
              </div>
            </div>

            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxAuthorizationUrl')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxAuthorizationUrl')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('taxAuthorizationUrl')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('taxAuthorizationUrl').errors?.notCompleted">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_AUTHORIZATION'|translate}}</label>

            <a [attr.href]="uploadUrl+uploadFolder+'/'+ taxAuthorization.URL" target="_blank">
              <i class="icon-view-file"></i>
              {{taxAuthorization.NameEN}}</a>
          </div>

          <div class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.TAX_AUTHORIZATION_EXPIRATION_DATE'|translate}}</label>
            <span class="red"> *</span>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
              formControlName="taxAuthorizationExpirationDate" 
              [ngClass]="{ 'is-invalid': formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxAuthorizationExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxAuthorizationExpirationDate')?.errors) }">

            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('taxAuthorizationExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('taxAuthorizationExpirationDate')?.errors)"
              class="red ">
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('taxAuthorizationExpirationDate')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('taxAuthorizationExpirationDate')?.errors?.inValidDateError">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>

          <!-- <div class="form-group" *ngIf="formMode== FormMode.Edit">
            <a [attr.href]="commercialRecord.URL" target="_blank">{{commercialRecord.NameEN}}</a>

          </div> -->

          <div *ngIf="formMode != FormMode.Readonly" class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.COMMERCIAL_RECORD'|translate}}</label>
            <span class="red"> *</span>

            <input type="file"
              accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
              MaxSizeInMB="5" class="form-control" id="commercialRecord" formControlName="commercialRecordUrl"
              (change)="onFileSelected($event,5,'commercialRecordProgress')"
              [ngClass]="{ 'is-invalid': formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('commercialRecordUrl')?.dirty && updateAgentForm.get('agentCertificate')?.get('commercialRecordUrl')?.errors) }" />
            <div class="upload-info">
              <span data-toggle="tooltip"
                title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="commercialRecordProgress + '%'">
                <span class=""> {{commercialRecordProgress}} % Complete</span>
              </div>
            </div>
            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('commercialRecordUrl')?.dirty && updateAgentForm.get('agentCertificate')?.get('commercialRecordUrl')?.errors)"
              class="red ">
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('commercialRecordUrl')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="updateAgentForm.get('agentCertificate')?.get('commercialRecordUrl').errors?.notCompleted">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.COMMERCIAL_RECORD'|translate}}</label>
            <a [attr.href]="uploadUrl+uploadFolder+'/'+  commercialRecord.URL" target="_blank">
              <i class="icon-view-file"></i>
              {{commercialRecord.NameEN}}</a>
          </div>

          <div class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.COMMERCIAL_RECORD_EXPIRATION_DATE'|translate}}</label>
            <span class="red"> *</span>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
              formControlName="commercialRecordExpirationDate"
              [ngClass]="{ 'is-invalid': formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('commercialRecordExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('commercialRecordExpirationDate')?.errors) }">

            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('commercialRecordExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('commercialRecordExpirationDate')?.errors)"
              class="red ">
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('commercialRecordExpirationDate')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('commercialRecordExpirationDate')?.errors?.inValidDateError">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>
          </div>

          <!-- <div class="form-group" *ngIf="formMode== FormMode.Edit && otherDocuments">
            <a [attr.href]="otherDocuments.URL" target="_blank">{{otherDocuments.NameEN}}</a>
          </div> -->
          <div *ngIf="formMode != FormMode.Readonly" class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.OTHER_DOCUMENTS'|translate}}</label>

            <input type="file"
              accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
              MaxSizeInMB="5" class="form-control" id="otherDocuments" formControlName="otherDocumentsUrl"
              (change)="onFileSelected($event,6,'otherDocumentsProgress')" />
            <div class="upload-info">
              <span data-toggle="tooltip"
                title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="otherDocumentsProgress + '%'">
                <span class=""> {{otherDocumentsProgress}} % Complete</span>
              </div>
            </div>
            <div *ngIf="updateAgentForm.get('agentCertificate')?.get('otherDocumentsUrl').errors?.notCompleted">
                {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
            </div>
          </div>

          <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && otherDocuments">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.OTHER_DOCUMENTS'|translate}}</label>

            <a [attr.href]="uploadUrl+uploadFolder+'/'+  otherDocuments.URL" target="_blank">
              <i class="icon-view-file"></i>
              {{otherDocuments.NameEN}}
            </a>
          </div>

          <div class="form-group">
            <label>{{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_CERTIFICATES_FORM.OTHER_DOCUMENTS_EXPIRATION_DATE'|translate}}</label>
            <!-- (bsValueChange)="onValueChange($event,updateAgentForm.get('agentCertificate')?.get('otherDocumentsExpirationDate'))"/ -->
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
              formControlName="otherDocumentsExpirationDate"  >
            <div
              *ngIf="formSubmitted ||(updateAgentForm.get('agentCertificate')?.get('otherDocumentsExpirationDate')?.dirty && updateAgentForm.get('agentCertificate')?.get('otherDocumentsExpirationDate')?.errors)"
              class="red ">
              <div
                *ngIf="updateAgentForm.get('agentCertificate')?.get('otherDocumentsExpirationDate')?.errors?.inValidDateError">
                {{'FRONT_USER.DATE_ERROR' | translate}}
              </div>
            </div>

          </div>
        </div>
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(1)">{{ 'FRONT_USER.PREVIOUS' | translate}}</button>
        </p>
      </tab>
      <!---end tab3 -->
    </tabset>

    <p *ngIf="formMode == FormMode.Edit && isTabOneValid && isTabTwoValid" class="btns-holder">
      <button Confirmation  (confirmationClick)="onSubmit()"  class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SUBMIT' | translate}}</button>
      <a routerLink="/workspace" class="btn btn-link SCAcustomBtn">{{ 'FRONT_USER.CANCEL' | translate}}</a>
    </p>

  </form>


</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage && !DuplicateNationalId && !DuplicateUserName" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>

  </div>
</div>


<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && DuplicateNationalId" class="alert alert-danger" role="alert">
    <div class="alignC">
      <i class="icon-error"></i>
  
      <p>{{'FRONT_USER.ERRORS_MESSAGES.DuplicateNationalId' | translate}}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
  </div>

  <div *ngIf="showRequest && DuplicateUserName" class="alert alert-danger" role="alert">
      <div class="alignC">
        <i class="icon-error"></i>
    
        <p>{{'FRONT_USER.ERRORS_MESSAGES.DuplicateUserName' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
            {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
      </div>
    </div>

<app-messaging></app-messaging>